/**
 * Typed Redux Hooks
 *
 * Pre-typed versions of useDispatch and useSelector.
 * Use these throughout the app instead of plain react-redux hooks
 * to get full TypeScript autocomplete on state and dispatch.
 *
 * Usage:
 *   const region = useAppSelector(state => state.env.region);
 *   const dispatch = useAppDispatch();
 *   dispatch(setRegion('us-west-2'));
 */
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
